










import { Component, Vue, Prop } from 'vue-property-decorator';
import { GQL_duplicateInvoice } from '@/queries/__generated__/duplicateInvoice';
import { GQL_invoice_invoice } from '@/queries/__generated__/invoice';
import i18n from '@/i18n';
import gql from 'graphql-tag';

const DUPLICATE_INVOICE = gql`
  mutation duplicateInvoice($invoiceId: ID!) {
    duplicateInvoice(
      input: {
        invoiceId: $invoiceId,
      }) {
      orders {
        id
        number
      }
    }
  }
`;

@Component
export default class DuplicateInvoiceButton extends Vue {
  @Prop() public invoice!: GQL_invoice_invoice;

  private loading = false;

  private duplicateInvoice() {
    // i18n.t used instead of this.$t because function is async and component calling it might be destroyed, making 'this' undefined
    this.$sMessage.info(i18n.t('Message.processing'), { duration: 1000 });
    this.loading = true;

    this.$apollo.mutate({
      mutation: DUPLICATE_INVOICE,
      variables: {
        invoiceId: this.invoice.id,
      },
    }).then(({ data }) => {
      this.redirectToCreated(data);
    }).finally(() => {
      this.loading = false;
    });
  }

  private redirectToCreated(data: GQL_duplicateInvoice) {
    const orders = data.duplicateInvoice?.orders || [];
    // i18n.t used instead of this.$t because function is async and component calling it might be destroyed, making 'this' undefined
    if (orders.length < 1) { this.$sMessage.error(i18n.t('Message.somethingWentWrong')); return }

    if (orders.length > 1) {
      this.$router.push({
        name: 'Orders',
        query: { orderIds: orders.map(o => o.id) },
      }, () => {
        // i18n.t used instead of this.$t because function is async and component calling it might be destroyed, making 'this' undefined
        this.$sMessage.success(i18n.tc(
          'Message.duplicatedInvoice',
          orders.length,
          {
            invoiceNumber: this.invoice.number,
            orderNumbers: orders.map(o => o.number).join(', '),
          },
        ) as string,
        { duration: 0 });
      });
    } else {
      this.$router.push({
        name: 'OrdersEdit',
        params: { id: orders[0].id },
      }, () => {
        // i18n.t used instead of this.$t because function is async and component calling it might be destroyed, making 'this' undefined
        this.$sMessage.success(
          i18n.tc(
            'Message.duplicatedInvoice',
            orders.length,
            {
              invoiceNumber: this.invoice.number,
              orderNumbers: orders[0].number,
            }) as string,
          { duration: 10000 },
        );
      });
    }
  }
}
